import { connect } from 'react-redux';
import Component from './StudentsList.component';
import { closeStudentsList } from '../../+store/aToF';

const mapStateToProps = (state) => {
  const year = state.modules.AtoF.aToF.filters.schoolYear;
  const roster = state.modules.StudentRoster.studentRoster.roster;
  const studentsListData = state.modules.AtoF.aToF.showStudentsList;
  return {
    students: year && roster ? roster[year - 1] : null,
    studentsList: studentsListData ? studentsListData.students : null,
    studentVersions: studentsListData ? studentsListData.versions : null,
    rowLabel: studentsListData ? studentsListData.rowLabel : null,
    indicatorLabel: studentsListData ? studentsListData.indicatorLabel : null,
    avatars: state.modules.StudentRoster.studentRoster.avatars,
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleClose: () => {
    dispatch(closeStudentsList());
  },
});

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default Container;
